import { Action, Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { Trader, traderApi } from '@/api'

@Module({
  name: 'TraderStore',
  namespaced: true,
  stateFactory: true
})
export default class TraderStore extends BaseStore {
  items: Trader[] = []

  get allItems(): Trader[] {
    return this.items
  }

  get findByCode(): (code: string) => Trader | undefined {
    return code => this.items.find(item => item.code === code)
  }

  get findById(): (id: number) => Trader | undefined {
    return id => this.items.find(item => item.id === id)
  }

  @Mutation
  public setItems(traders: Trader[]) {
    this.items = traders
  }

  @Action
  public async fetchAll() {
    const traders: Trader[] = await traderApi.getTrader()
    this.setItems(traders)
  }
}
